export const main = {
    "name": "Nafiz Sheikh",
    "description": "I'm full stack web developer",
    "image": "profilepic.jpg",
    "bio": "I am Nafiz Sheikh. A young entrepreneur. With nearly 2 years of experience, I’m a Full Stack. Worked as a senior lead full-stack developer at OpticEngine had been a rewarding experience. Moreover, I work on a few startups aimed at the Bangladesh, Russian, Chinese, American, and Dutch markets. Among the companies and entrepreneurs I have worked with are DP-Websolutions, Ganlax group, Hyvinvoivin, Happy-Dairy, Arrtal, FN Softwares & institute, and many more. Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    "email": "nafizsheikh394@gmail.com",
    "phone": "+880 1875799476",
    "quote": "The universe is a pretty big place. If it's just us.",
    "address": "Nawabganj, Dhaka, Bangladesh",
    "website": "https://nafizsheikh.com",
    "resumedownload": "",
    "social": [
        {
            "name": "linkedin",
            "url": "https://www.linkedin.com/in/nafiz-sheikh-32a212215",
            "iconName": "logo-linkedin"
        },
        {
            "name": "youtube",
            "url": "https://www.youtube.com/channel/UCnB4KpNefnQoMvrf7t1vpPQ",
            "iconName": "logo-youtube"
        },
        {
            "name": "facebook",
            "url": "https://www.facebook.com/nafiz.nafizahmed.1",
            "iconName": "logo-facebook"
        },
        {
            "name": "instagram",
            "url": "https://www.instagram.com/nafiz456/",
            "iconName": "logo-instagram"
        },
        {
            "name": "github",
            "url": "https://github.com/nafizsheikh12",
            "iconName": "logo-github"
        }
    ]
}

export const about = {
    "bio": "I am a full stack<br /><span class='text-primary'>web developer</span> who cares<br /> about the code and the people.",
    "ido": "<p>WEB DEVELOPMENT</p><p>FRONT-END DEVELOPMENT</p><p>BACK-END DEVELOPMENT</p><p>FULL-STACK DEVELOPMENT</p>",
    "years": 2,
    "image": "img/profilepic.jpg",
    // "video": "https://www.youtube.com/watch?v=ghQd1PbzVaY",
    "resumedownload": "https://docs.google.com/document/d/1GXjSz0-phEr2dr5mojArwraFAnDpzLGcMBcw1vJw4z8/edit?usp=sharing",
}

export const works = [
    [
        
        {
            "company": "DP-Websolutions",
            "title": "Full-Stack Developer & UI/UX designer",
            "image": "img/behance.png",
            "years": "July 2020 - Present",
            "description": "• Dedicated years of collaborative effort resulted in 30% increase in company revenue <br />• Responsible for testing applications and looking for bugs & monitoring website performance <br />• Responsible for application code and UI/UX design <br />• Built responsive custom WordPress themes from scratch also with DIVI theme <br />• Optimized company website for performance and Search Engine Optimization"
        },
        {
            "company": "OpticEngine",
            "title": "Senior Lead Full-Stack Web & Mobile Developer",
            "image": "img/behance.png",
            "years": "June 2021 - October 21",
            "description": "• Built websites with React JS and node js as backend <br />• Designing web and mobile apps mockups using Figma <br />• Designed and built the User Interface of the mobile app with React-native <br />• Assist the backend developer on ongoing development projects <br />• Participating in all decision-making processes which includes the database design, tooling, deployment processes etc"
        },
        {
            "company": "FN Softwares & institute",
            "title": "Trainer & Full-Stack Developer",
            "image": "img/behance.png",
            "years": "Aug 20 - Present",
            "description": "• Trained programming over 500+ students on 2 successful courses <br />• Developed beta version of 'eSomaz (a social media)' app, used by 20K+ active users (increased active user by 25%) <br />• Developed a VS Code Extension for 'eSomaz' which helped to connect programmers <br />• Worked as an adviser on decision-making processes • Motivated jr developers on programming & life "
        },
    ],
    [
        {
            "company": "Ganlax Group",
            "title": "Web Developer",
            "image": "img/behance.png",
            "years": "May 20 - Present",
            "description": "• Built the company website with custom WordPress themes from scratch <br />• Optimized company website for performance and Search Engine Optimization <br />• Developed Custom Post Types and created custom fields with ACF plugins <br />• Sliced up design assets from Photoshop files when building custom themes <br />• Performed maintenance tasks on pre-existing sites using the Infinite WP dashboard, such as updating plugins, ensuring backups are running, and running security scans"
        },
        {
            "company": "KS Devware",
            "title": "Founder",
            "image": "img/behance.png",
            "years": "March 2021 - Present",
            "description": "• Developing revenue-generating applications at both small and large scales <br />• Providing comprehensive maintenance support <br />• Improving the user interface <br />• Building apps for self-health and helping the nation"
        },
    ]
]

export const skills = {
    title: "My mission is to create an impact <span class='text-primary'>globally</span>",
    subtitle: "Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    skills: [
        {
            "title": "Front-end",
            skills: ["JavaScript", "React JS","HTML/CSS","Jquery", "Redux"]
        },
        {
            "title": "Back-end",
            skills: ["Node JS", "Express JS", "Rest API"]
        },
        {
            "title": "Database",
            skills: ["MongoDB", "Firebase"]
        },
        {
            "title": "Libraries",
            skills: ["Bootstrap", "Material UI","Tailwind"]
        },
        {
            "title": "Others",
            skills: ["Git", "GitHub","Figma", "AJAX", "WordPress",]
        },
    ]
}

export const projects = [
    {
        "title": "Metablog website",
        "category": "Website",
        "image": "metablog.png",
        "url": "https://metablogs.netlify.app"
    },
    {
        "title": "Whatsapp Clone",
        "category": "Website",
        "image": "whatsappclone.png",
        "url": "https://whatsapp-masterclone.netlify.app"
    },
    {
        "title": "Flipkart Clone",
        "category": "Website",
        "image": "flipkart.png",
        "url": "https://flipkart-masterclone.netlify.app/"
    },
    {
        "title": "Brigate Website",
        "category": "Website",
        "image": "brigate.png",
        "url": "https://meta-ks.vercel.app/"
    }
   
]

export const partners = [
    {
        image: "1.png"
    },
    {
        image: "2.webp"
    },
    {
        image: "4.png"
    },
    {
        image: "workslee.png"
    },
    {
        image: "gorelove.png"
    },
    {
        image: "3.png"
    },
]

export const testimonials = [
    {
        "text": "We are very content and happy wan all the work Khalid Saifullah has done for us! Not only did he just what he had to do, comes up with suggestions and improvements of his owns and points out weaknesses which he in perfect communication is able to improve. Recommended! ",
        "user": "Jason Sindram",
        "company": "CTO at DP-Websolutions"
    },
    {
        "text": "Superb. Great comms, understood the requirement, and delivered quickly. Multiple revisions allowed which were very helpful. I will work with him again.",
        "user": "Bhavesh Patel",
        "company": "CEO at Ganlaxgroup"
    }
]

